import DataParser from "../../utlits/Dataparser";
import UserProfile from "./UserProfile.";
import UserServices from "../../Services/UserService";
import React, { useEffect, useState } from "react";
import Select from "react-select";

const AssigneField = (props) => {
  const { item, assigne, Services, Owner, newOwner, localUpdate } = props;
  const [leadAssigne, setLeadAssigne] = useState(newOwner || Owner?.id);
  const [users, setUsers] = useState([]);

  // Use the Owner prop to get the initial name, but we also need to handle local state changes
  const getDisplayName = (user) => {
    if (!user) return "Select Owner";
    return user.full_name || `${user.first_name || ""} ${user.last_name || ""}`.trim() || `User ${user.id}`;
  };

  const [leadAssigneName, setLeadAssigneName] = useState(getDisplayName(Owner));

  useEffect(() => {
    setLeadAssigne(newOwner || Owner?.id);
    setLeadAssigneName(getDisplayName(Owner));
  }, [newOwner, Owner]);

  const options = (assigne || []).map(user => ({
    value: user.id,
    label: user.full_name || `${user.first_name || ""} ${user.last_name || ""}`.trim() || `User ${user.id}`
  }));

  const selectedOption = options.find(opt => Number(opt.value) === Number(leadAssigne));

  const customStyles = {
    container: (provided) => ({
      ...provided,
      border: "none !important",
      boxShadow: "none !important",
      outline: "none !important",
      ...(props.styles || {})
    }),
    control: (provided, state) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
      outline: "none",
      borderRadius: "0",
      minHeight: "26px",
      height: "26px",
      display: "flex",
      alignItems: "center",
      backgroundColor: "transparent",
      cursor: "pointer",
      "&:hover": { border: "none", boxShadow: "none" },
      "&:focus": { border: "none", boxShadow: "none", outline: "none" },
      "&:focus-within": { border: "none", boxShadow: "none", outline: "none" },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
      minHeight: "26px",
      height: "26px",
      display: "flex",
      alignItems: "center",
      margin: 0,
      border: "0 !important",
      boxShadow: "none !important",
      outline: "none !important",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      color: props.textColor || "#1d1d1d",
      height: "26px",
      display: "flex",
      alignItems: "center",
      border: "0 !important",
      boxShadow: "none !important",
      outline: "none !important",
      fontSize: props.styles?.fontSize || "13px",
      fontWeight: 500,
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: 0,
      color: props.textColor || "#1d1d1d",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: props.styles?.fontSize || "13px",
      fontWeight: 500,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "26px",
      alignItems: "center",
    }),
    placeholder: (provided) => ({
      ...provided,
      margin: 0,
      color: "#6c757d",
      fontSize: props.styles?.fontSize || "13px",
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 1000000 }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000000,
      width: "max-content",
      minWidth: "100%",
      borderRadius: "8px",
      boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
      border: "1px solid #e9ecef",
      overflow: "hidden",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "4px 0",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#f0fdf9" : state.isFocused ? "#f5fef9" : "transparent",
      color: "#1d1d1d",
      fontWeight: state.isSelected ? "500" : "400",
      cursor: "pointer",
      padding: "8px 12px",
      fontSize: props.styles?.fontSize || "13px",
      "&:active": { backgroundColor: "#f0fdf9" },
    }),
  };

  const handleLeadAssigne = (selected) => {
    if (!selected) return;

    setLeadAssigne(selected.value);
    setLeadAssigneName(selected.label);
    
    const id = item.id;
    const companyId = DataParser.CompanyId();
    const companyIdentifier = DataParser.CompanyIdentifier();
    const leadAssigneInt = parseInt(selected.value);

    // For Projects we use 'owner', for Tasks we might use 'asigned_to'
    // We'll check if item has 'owner' property to decide
    const updateData = ('owner' in item) ? { owner: leadAssigneInt } : { asigned_to: leadAssigneInt };

    // Optimistic Update
    if (localUpdate) {
      localUpdate(id, updateData);
    }

    const LeadsData = {
      ...updateData,
      company_id: companyId,
      company_identifier: companyIdentifier,
      assignee: leadAssigneInt,
    };
    
    if (Services) {
      Services(id, LeadsData).then((res) => {
        // Success
      }).catch(err => console.error("Update failed", err));
    }
  };

  const currentUser = (assigne || []).find(u => Number(u.id) === Number(leadAssigne)) || Owner;
  const currentImage = currentUser?.image || currentUser?.profile_picture;

  const avatarSize = props.avatarSize || (props.styles?.fontSize ? `${parseInt(props.styles.fontSize) + 4}px` : "18px");

  return (
    <div className="assignee-field-wrap" style={{ display: "flex", alignItems: "center", gap: "2px", width: "100%" }}>
      <UserProfile username={leadAssigneName} userImage={currentImage} bgColor={props.bgColor} style={{ width: avatarSize, height: avatarSize, borderRadius: '6px', flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          value={selectedOption}
          onChange={handleLeadAssigne}
          options={options}
          styles={customStyles}
          theme={(theme) => ({
            ...theme,
            colors: { ...theme.colors, primary: 'transparent', primary25: '#f5fef9', primary50: '#f0fdf9' },
          })}
          isSearchable={true}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          isDisabled={props.disabled}
          components={{ IndicatorSeparator: () => null }}
        />
      </div>
    </div>
  );
};

export default AssigneField;
